<template>
    <BCard v-if="course">
    <ValidationObserver ref="form">
        <BForm @submit.prevent="update">
            <BRow>
                <TextInputValidated vsName="Code" :vsModel.sync="course.code" vsMd="6" vsRequired vsRules="required"/>
                <TextInputValidated vsName="Name" :vsModel.sync="course.name" vsMd="6" vsRequired vsRules="required"/>
                <NumberInputValidated vsName="Matrícula" :vsModel.sync="course.amount" vsStep="0.01" vsMd="6" vsRequired vsRules="required"/>
                <NumberInputValidated vsName="Places" :vsModel.sync="course.places" vsMd="6" vsRequired vsRules="required" />
                <vSelectValidated vsName="Group" v-if="groups && groups.length>1" :vsReduce="group => group.id" :vsModel.sync="course.group_id" :vsOptions="groups"  vsLabel="name" vsMd="6" :vsClearable="true"/>
                <vSelectValidated vsName="Section" :vsReduce="section => section.id" :vsModel.sync="course.section_id" :vsOptions="sections" vsLabel="name" vsMd="6" vsRequired vsRules="required"/>
                <vSelectValidated vsName="Tax" :vsReduce="tax => tax.id" :vsModel.sync="course.tax_id"  :vsOptions="taxes" vsLabel="name" vsMd="6" vsRequired vsRules="required"/>
                <DatepickerValidated vsName="Enrollment start date" :vsModel.sync="course.enrollment_start_date" vsMd="6" vsRequired vsRules="required" />
                <DatepickerValidated vsName="Enrollment end date" :vsModel.sync="course.enrollment_end_date" vsReset vsMd="6" :vsMin="course.enrollment_start_date"/>

                <BCol cols="12">
                    <BFormGroup label="Opciones de pago" v-slot="{ ariaDescribedby }">
                        <BCol>
                            <BRow>
                                <BFormRadio v-model="paymentType" class="mr-2" :aria-describedby="ariaDescribedby" name="some-radios" value="mensual">Pago mensual</BFormRadio>
                                <BFormRadio v-model="paymentType" :aria-describedby="ariaDescribedby" name="some-radios" value="plazos">Pago a plazos</BFormRadio>
                            </BRow>
                        </BCol>

                    </BFormGroup>
                    </BCol>
                    <!-- Pago mensual -->
                    <BCol cols="12" v-if="paymentType=='mensual'">
                        <BRow>
                            <NumberInputValidated vsName="Mensualidad" vsStep="0.01" :vsModel.sync="course.monthly_payment" vsMd="6" vsRequired :vsRules=" paymentType=='mensual' ? 'required':''"/>
                            
                            <div class="d-none d-md-block col-md-6"></div>
                            <DatepickerValidated vsName="Start date" :vsModel.sync="course.start_date" vsMd="6" vsRequired :vsRules="paymentType=='mensual' ? 'required':''"/>
                            <DatepickerValidated vsName="End Date" :vsModel.sync="course.end_date" vsMd="6" :vsMin="course.start_date" vsReset/>

                            <vSelectValidated vsName="Porcentaje del primer mes" :vsOptions="percentageOptions" :vsModel.sync="course.first_month_percentage" :vsReduce="percentage => percentage.value" vsLabel="name" vsMd="6" vsRequired :vsRules="paymentType=='mensual' ? 'required':''" />
                            <vSelectValidated v-if="course.end_date" vsName="Porcentaje del último mes" :vsClearable="true" :vsOptions="percentageOptions" :vsModel.sync="course.last_month_percentage" :vsReduce="percentage => percentage.value" vsLabel="name" vsMd="6"  />

                        </BRow>
                    </BCol >

                    <!-- Pago a plazos -->
                    <DatepickerValidated vsRequired :vsRules="paymentType=='plazos' ? 'required':''" v-if="paymentType=='plazos'" vsName="Fecha de alta del curso" :vsModel.sync="course.start_date" vsMd="6"  />
                    <DatepickerValidated vsRequired :vsRules="paymentType=='plazos' ? 'required':''" :vsMin="terms[terms.length-1] ? terms[terms.length-1].start_date : ''" v-if="paymentType=='plazos'" vsName="Fecha de baja del curso" :vsModel.sync="course.end_date" vsMd="6"  />
                    <BCol cols="12" v-if="paymentType=='plazos'">
                        <div class="repeater-form ">
                            <BRow v-for="(term, index) in terms" :key="index" class="border rounded p-1 my-1">
                                <BCol cols="12"> 
                                    <BRow> 
                                        <BCol> 
                                            <p>Plazo {{ index+1 }}</p> 
                                        </BCol> 
                                    <feather-icon @click="removeTerm(index)" size="16" icon="XIcon" class="cursor-pointer"/>
                                    </BRow>
                                </BCol>

                                <BCol>
                                    <BRow>

                                        <DatepickerValidated vsName="Start date" :vsModel.sync="term.start_date" vsMd="6" vsRequired vsRules="required" :vsRules="paymentType=='plazos' ? 'required':''" :vsMin=" terms[index-1] ? terms[index-1].start_date: (course.start_date ? course.start_date : '')"/>
                                        <NumberInputValidated vsName="Amount" vsStep="0.01" :vsModel.sync="term.term_payment" vsMd="6" vsRequired vsRules="required" :vsRules="paymentType=='plazos' ? 'required':''"/>
                                    </BRow>
                                </BCol>
                                
                            </BRow>
                        </div>
                        <BButton @click="addNewTerm" class="m-1" size="sm" variant="primary"> Añadir plazo </BButton>
                    </BCol>



                <CheckboxValidated vsName="show_tpv" vsLabel="Show in TPV" :vsModel.sync="course.show_tpv" />
                <CheckboxValidated vsName="show_student_tpv" vsLabel="Show in student TPV" :vsModel.sync="course.show_student_tpv" />
            </BRow>
            <BRow class="mt-3">
                <BCol>
                    <BButton class="mb-1 mb-sm-0 mr-0 mr-sm-1" variant="primary" type="submit" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{ $t('Save Changes') }} </BButton>
                    <BButton variant="outline-secondary" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="cancel"> {{ $t('Cancel') }} </BButton>
                </BCol>
            </BRow>
        </BForm>
    </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BForm, BRow, BCol, BFormRadio, BFormGroup, BFormInput, BFormInvalidFeedback, BFormDatepicker, BButton } from 'bootstrap-vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { onUnmounted, ref, watch } from '@vue/composition-api';
import { numeric, required } from 'vee-validate/dist/rules';
import formValidation from '@core/comp-functions/forms/form-validation'
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import vSelectValidated from '@/components/forms/vSelectValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import courseModule from '../courseModule'
import popups from '@/hooks/popups';
import VSelect from 'vue-select';
import router from '@/router';
import store from '@/store'
import axios from '@axios'


export default {
    components: { DatepickerValidated, BFormRadio, NumberInputValidated, TextInputValidated, vSelectValidated, BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormInvalidFeedback, BFormDatepicker, BButton, ValidationObserver, ValidationProvider, VSelect, CheckboxValidated },
    setup() {
        const { getValidationState } = formValidation()
        const { errorToast, successToast } = popups()
        const form = ref(null)
        const course = ref(null)
        const terms=ref(null)
        const groups = ref([])
        const sections = ref([])
        const taxes = ref([])
        const COURSE_MODULE = 'courses'
        const paymentType=ref(null)
        const term={
            course_id:null,
            start_date: null,
            term_payment:null
        }

        const percentageOptions=[
            { name: "0%", value: 0  },
            { name: "25%", value: 25  },
            { name: "50%", value: 50  },
            { name: "75%", value: 75  },
            { name: "100%", value: 100  },
        ]

        const cancel = function(){
            router.push({name: 'courses'})
        }

        const addNewTerm=() => {
            terms.value.push(JSON.parse(JSON.stringify(term)))
        }

        const removeTerm=(index) => {
            terms.value.splice(index, 1)
        }

        const update = function(){

            if (course.value.group_id) {course.value.group=course.value.group.id;}
            if (course.value.section.id) {course.value.section=course.value.section.id}

            form.value.validate().then(success => {
                if(success) {
                    store.dispatch('courses/updateCourse', {course: JSON.parse(JSON.stringify(course.value)), terms:terms.value, type: paymentType.value })
                        .then(response => { 

                            if (response.data.success) {
                                router.push({ name: 'courses' }) 
                                successToast("Curso actualizado correctamente")                                
                            }  else {
                                errorToast("Error actualizando el curso.")
                            }
                            
                        }
                        )
                        .catch(error => { errorToast("Error actualizando el curso.") })
                }
            })
        }

        extend('required', required)
        extend('numeric', numeric)

        if (!store.hasModule(COURSE_MODULE)) {
            store.registerModule(COURSE_MODULE, courseModule)
        }

        onUnmounted(() => {
            if (store.hasModule(COURSE_MODULE)) {
                store.unregisterModule(COURSE_MODULE)
            }
        })

        store.dispatch('courses/editCourse', { id: router.currentRoute.params.id }).then(response => {
                course.value = response.data.course
                terms.value=response.data.terms
                groups.value = response.data.groups
                sections.value = response.data.sections
                taxes.value = response.data.taxes

                if (terms.value.length==0) {
                    paymentType.value="mensual"
                }else {
                    paymentType.value="plazos"
                }

            })

        watch(paymentType, () => {
            if (paymentType.value=="mensual") {
                terms.value=[JSON.parse(JSON.stringify(term))]
            } else if (paymentType.value=="plazos") {
                course.value.first_month_percentage=null
                course.value.last_month_percentage=null
                course.value.monthly_payment=null
            }
        })

        return {
            getValidationState,
            course,
            cancel,
            update,
            groups,
            sections,
            form,
            taxes,
            paymentType,
            addNewTerm,
            removeTerm,
            percentageOptions,
            terms,
        }
    }
}
</script>

<style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
</style>
